import { service } from '../axios';
export function getFlowDefRecord(params) {
    return service({ url: '/flowDefinition/getFlowRecord', method: 'get', params });
}
export function saveFlowDef(data) {
    return service({ url: '/flowDefinition/saveFlow', method: 'post', data });
}
export function getFlowDefCreate(params) {
    return service({ url: '/flowUserProcess/getFlowCreate', method: 'get', params });
}
export function getFlowDefList(params) {
    return service({ url: '/flowDefinition/getFlowList', method: 'get', params });
}
export function getFlowDefOperations(params) {
    return service({ url: '/flowDefinition/getOperations', method: 'get', params });
}
export function execFlowDefOperation(data) {
    return service({ url: '/flowDefinition/execOperation', method: 'post', data });
}
